module.exports = "\n<div class=\"modal-content\">\n  <div style=\"background: linear-gradient(#103f56, #094868, #00527c, #066f9e) !important;\" class=\"modal-header\">\n    <h4 style=\"color:#ffffff\" class=\"modal-title\">IDAS says:</h4>\n  </div>\n  <div class=\"modal-body\">{{message}}</div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-accent\" (click)=\"ok()\">Ok</button>\n    <button *ngIf=\"isconfirm\" type=\"button\" class=\"btn btn-accent\"  (click)=\"close()\">Cancel</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/popup/popup.component.html
// module id = ./src/app/popup/popup.component.html
// module chunks = main